import { ActivityEntityName, Company, DomainType } from '@jms/model';
import type { EntityManifestCard } from '@workbuddy/services/entities/entity.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

// Tenant Company entity manifest. Card-only: Company is referenced by other records (activities,
// portals) but has no board or page of its own, so the same card serves tenant and both portals.
const card: EntityManifestCard<Company> = {
  component: () => import('./entity.card.renderer/company.entity.card.renderer.component').then(module => module.CompanyEntityCardRendererComponent),
  resolution: 'if-needed',
  isComplete: value => !!(value.phone || value.email || value.address?.street1 || value.address?.suburb),
  summarize: value => ({ title: value.name ?? 'Not set' }),
};

export const companyManifest = registerManifest<Company>({
  entity: ActivityEntityName.Company,
  slug: 'company',
  presentation: { card },
  domains: {
    [DomainType.ClientPortal]: { presentation: { card } },
    [DomainType.ContractorPortal]: { presentation: { card } },
  },
});
